import router from "@/router";
import ApiClient from "@/api/ApiClient";

const urlHandler = {
    /**
     * Check if url is the same as sent 'route'
     * @param {String} route 
     * @returns {Bool}
     */
    checkUrl(route = ''){
        return window.location.pathname == route;
    },

    /**
     * Redirects to sent url
     * @param {String} url 
     */
    async redirect(url = '/') {
        if (typeof url === 'string') {
            await router.push({path: url});
        } else {
            await router.push({ name: url.name, query: url.query });
        }
    },
    

    /**
     * Open url address
     * @param {String} url
     * @param {String} target 
     */
    openLink(url = '', target = '_blank') {
        if (url == '') {
            return null;
        }
        window.open(url, target);
    },

    /**
     * Checks if url is valid
     * @param {String} urlLink 
     * @returns {Bool}
     */
    async isUrlValid(urlLink = '') {
        try {
            const parsed = new URL(urlLink)
            if (!['http:', 'https:'].includes(parsed.protocol)) {
                return false;
            }

            const response = await this.checkUrlStatus(urlLink);
            return response;
        } catch (error) {
            return false;
        }
    },

    /**
     * Calls API requesting url check
     * @param {String} urlLink 
     * @returns {Bool}
     */
    async checkUrlStatus(urlLink = '') {
        const apiClient = new ApiClient('api/');
        const result = await apiClient.executeRequest('check_url', {url: urlLink}, apiClient.methods.POST);

        let isValid = false;
        if (result.success()) {
            isValid = result.getContent()?.valid ?? false;
        }
        return isValid;
    }
}

export default urlHandler;